import { dataService } from '../api/api';

export const makeRequest = (endpoint, method, body = null) => {
    return new Promise((resolve) => {
      dataService.requestData(endpoint, method, body)
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          console.error("An error occurred:", error);
          resolve([]); 
        });
    });
  };
